<template>
  <FreeBottomSheet :name="name">
    <template #header="{ hide }">
      <FreeHeader class="p-4 text-center" is-centered>
        <template #default>
          {{ t('ancillaries.flightDelay.title') }}
        </template>
        <template #rightAction>
          <FreeCloseButton @click="hide" />
        </template>
      </FreeHeader>
    </template>

    <template #default>
      <div class="space-y-4 px-4 pb-4">
        <div class="bg-background-neutral-secondary rounded-2xl p-4">
          <p class="text-text-neutral-primary whitespace-pre-wrap text-sm">
            {{ t('ancillaries.flightDelay.details.description') }}
          </p>
        </div>
        <ConditionsButton
          :title="t('ancillaries.medicalInsurance.details.conditionsTitle')"
          @onBottomSheetOpen="
            bottomSheet.show(flightDelayConfig.CONDITIONS_BOTTOM_SHEET)
          "
        />
      </div>
    </template>
  </FreeBottomSheet>
</template>

<script setup lang="ts">
  import { FreeBottomSheet, FreeHeader, FreeCloseButton } from 'freedom-shared';
  import { useI18n } from 'vue-i18n';
  import { controllerModel } from 'shared';

  import { flightDelayConfig } from '../config';
  import ConditionsButton from './ConditionsButton.vue';

  defineProps<{
    name: string;
  }>();

  const { t } = useI18n();

  const bottomSheet = controllerModel.useBottomSheet();
</script>
